import { render, staticRenderFns } from "./FaqAnswer.vue?vue&type=template&id=27aa754a"
import script from "./FaqAnswer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaqAnswer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports